<template>
    <div class="popup-images__row" data-gallery="">
        <template v-for="(item, index) in galleryItems">
            <!-- Видео по ссылке: обычная ячейка с постером + кнопкой play -->
            <div
                v-if="item.kind === 'video_link'"
                :key="'video_' + index"
                class="popup-images__item"
                @click="playVideo($event, item.embed_url)"
            >
                <img :src="item.poster" alt="">
                <div class="youtube-play">
                    <div class="youtube-play-icon"></div>
                </div>
            </div>
            <!-- Загруженное видео: обычная ячейка с нативным плеером -->
            <div
                v-else-if="item.kind === 'video_file'"
                :key="'videofile_' + index"
                class="popup-images__item"
            >
                <video :src="item.url" :poster="item.poster || null" controls playsinline></video>
            </div>
            <!-- Изображение -->
            <a
                v-else
                :key="'image_' + index"
                :href="item.url"
                class="popup-images__item"
            >
                <img :data-src="item.url" alt="">
            </a>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import app from "../../app";
import FavoriteButton from "../favorites/FavoriteButton.vue";

export default {
    name: "ImagesGallery",
    props: {
        galleryItems: {
            type: Array,
            default: () => []
        },
        id: {
            type: Number,
            default: null,
        },
        isComplex: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.initLightGallery();
    },
    methods: {
        initLightGallery() {
            const galleries = document.querySelectorAll("[data-gallery]");
            galleries.forEach((gallery => {
                let isComponentAdded = false;
                gallery.addEventListener('lgBeforeOpen', () => {
                    if (!isComponentAdded) {
                        const container = document.createElement('div');
                        container.className = 'custom-toolbar-element';
                        document.querySelector('.lg-container.lg-show .lg-wrapper').append(container);
                        new Vue({
                            store: app.$store,
                            render: h => h(FavoriteButton, {
                                props: {
                                    id: this.id,
                                    isCatalog: false,
                                    isComplex: this.isComplex
                                }
                            })
                        }).$mount(container);

                        isComponentAdded = true;
                    }
                });
            }));
        },
        playVideo(event, embedUrl) {
            if (!embedUrl) return;

            const item = event.currentTarget; // .popup-images__item

            // Плеер уже вставлен — повторный клик не должен пересоздавать iframe
            // (перезапускать видео). Управление — через контролы самого плеера.
            if (item.querySelector('iframe')) return;

            const separator = embedUrl.includes('?') ? '&' : '?';

            const iframe = document.createElement('iframe');
            iframe.src = `${embedUrl}${separator}autoplay=1&playsinline=1`;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; fullscreen; encrypted-media');
            iframe.setAttribute('allowfullscreen', 'true');
            iframe.setAttribute('playsinline', 'true');

            // Заменяем постер и кнопку play на встроенный плеер, сохраняя ячейку сетки.
            item.innerHTML = '';
            item.appendChild(iframe);
        }
    }
}
</script>
